var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrecision = function SvgPrecision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    fill: "#E2FFEA",
    rx: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    stroke: "#F4FFF7",
    strokeWidth: 6,
    rx: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M34.667 30c3.333 0 6 2.667 6 6 0 1.173-.334 2.28-.92 3.2l4.106 4.133L42 45.187l-4.16-4.094a6 6 0 0 1-3.173.907c-3.334 0-6-2.667-6-6s2.666-6 6-6m0 2.667a3.334 3.334 0 1 0 0 6.667 3.334 3.334 0 0 0 0-6.667M20.667 18h18.666A2.66 2.66 0 0 1 42 20.667v10.706c-.667-1.066-1.587-1.986-2.667-2.706v-8H20.667v18.666h6A8.7 8.7 0 0 0 28.413 42h-7.746A2.66 2.66 0 0 1 18 39.333V20.667A2.66 2.66 0 0 1 20.667 18m2.666 5.333h13.334V26H23.333zm0 5.334h6.707c-1.067.666-1.987 1.586-2.707 2.666h-4zm0 5.333h2.894A9.3 9.3 0 0 0 26 36v.667h-2.667z"
  })));
};
export default SvgPrecision;